module.exports = __webpack_public_path__ + "img/avatar6.32f5eb23.jpg";